import type { SxProps, Theme } from "@mui/material/styles";

export const parameterControlsSx = {
  color: "#202a35",
  "& .MuiButton-root": {
    textTransform: "none",
    fontWeight: 400,
    fontSize: "0.875rem",
    letterSpacing: 0,
    color: "var(--newWork, #8c1ec8)",
    borderRadius: "var(--radius-medium, 0.75rem)",
    padding: "6px 12px",
    "&:hover": { backgroundColor: "#f7effc" },
    "&:focus-visible": {
      outline: "2px solid var(--newWork, #8c1ec8)",
      outlineOffset: "2px",
    },
    "&.Mui-disabled": { color: "#a1a1aa" },
    "&[data-variant='primary']": {
      backgroundColor: "var(--newWork, #8c1ec8)",
      color: "#fff",
      "&:hover": { backgroundColor: "var(--newWork80, #a34bd3)" },
      "&.Mui-disabled": { backgroundColor: "#e4e4e7", color: "#a1a1aa" },
    },
    "&[data-variant='outline']": {
      border: "1px solid var(--newWork30, #d6bce9)",
      "&:hover": {
        borderColor: "var(--newWork, #8c1ec8)",
        backgroundColor: "#f7effc",
      },
    },
    "&[data-variant='copy']": {
      minWidth: 0,
      maxWidth: "100%",
      padding: "8px 14px",
      gap: "8px",
      border: "1px solid var(--newWork30, #d6bce9)",
      backgroundColor: "#f7effc",
      "& .MuiButton-startIcon": { margin: 0, flexShrink: 0 },
      "& code": {
        background: "transparent",
        border: 0,
        padding: 0,
        minWidth: 0,
      },
    },
    "&[data-variant='danger']": {
      color: "#71717a",
      "&:hover": { color: "#b91c1c", backgroundColor: "#fef2f2" },
    },
  },
  "& .MuiInputLabel-root": {
    position: "static",
    transform: "none",
    pointerEvents: "auto",
    maxWidth: "100%",
    marginBottom: "6px",
    fontSize: "0.875rem",
    fontWeight: 400,
    color: "#334254",
    "&.Mui-focused": { color: "var(--newWork, #8c1ec8)" },
    "&.Mui-error": { color: "#b91c1c" },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "var(--radius-medium, 0.75rem)",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    "& fieldset": { top: 0, borderColor: "#dfe5e9" },
    "& legend": { display: "none" },
    "&:hover fieldset": { borderColor: "var(--newWork60, #ba78de)" },
    "&.Mui-focused fieldset": {
      borderColor: "var(--newWork, #8c1ec8)",
      borderWidth: "1px",
    },
    "&.Mui-focused": { boxShadow: "0 0 0 2px var(--newWork30, #d6bce9)" },
    "&.Mui-error fieldset": { borderColor: "#b91c1c" },
  },
  "& .MuiInputBase-input": { padding: "10px 12px" },
  "& .MuiSelect-select": { paddingRight: "32px" },
  "& .MuiFormHelperText-root": {
    margin: "6px 0 0",
    color: "#71717a",
    "&.Mui-error": { color: "#b91c1c" },
  },
  "& .MuiCheckbox-root": {
    color: "#a1a1aa",
    "&.Mui-checked": { color: "var(--newWork, #8c1ec8)" },
    "&:hover": { backgroundColor: "#f7effc" },
  },
  "& .MuiFormControlLabel-label": { fontSize: "0.875rem", fontWeight: 400 },
} satisfies SxProps<Theme>;
